export enum TreatmentType {
  Debridement = 1,
  Antibiotic = 2,
  Cream = 3,
  Solution = 4,
  Other = 5,
}
